import { render } from "./tag.html?vue&type=template&id=faf86eba&scoped=true&ts=true&external"
import script from "./tag.ts?vue&type=script&lang=ts&external"
export * from "./tag.ts?vue&type=script&lang=ts&external"

import "./tag.scss?vue&type=style&index=0&id=faf86eba&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf86eba"]])

export default __exports__